// TSS vite/06 — env-driven config. Throws at boot if required vars are missing.

const required = ['VITE_API_ENDPOINT'];
const missing = required.filter(k => !import.meta.env[k]);
if (missing.length) {
    throw new Error(`[boot] missing env: ${missing.join(', ')}`);
}

export const api = {
    endpoint: import.meta.env.VITE_API_ENDPOINT,
};

export const cdn = {
    public: import.meta.env.VITE_CDN_PUBLIC || null,
};

export const meta = {
    projectName: import.meta.env.VITE_PROJECT_NAME || 'Trianametria App',
};
